// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v6qn","footer":"styles_footer__2xPuO","passCodeTooltip":"styles_passCodeTooltip__3hwOA"};